export const SET_OUTPUT = 'SET_OUTPUT';
export const SET_ERROR = 'SET_ERROR';
export const SET_LOADING_TRUE = 'SET_LOADING_TRUE';
export const SET_AUTH_SUCCESS = 'SET_AUTH_SUCCESS';
export const SET_AUTH_FAILURE = 'SET_AUTH_FAILURE';
export const LOGOUT = 'LOGOUT';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const INTERVIEW_LINK_GENERATION_SUCCESS =
  'INTERVIEW_LINK_GENERATION_SUCCESS';
export const INTERVIEW_LINK_GENERATION_FAILURE =
  'INTERVIEW_LINK_GENERATION_FAILURE';
export const SET_INTERVIEW_LINK_LOADING_TRUE =
  'SET_INTERVIEW_LINK_LOADING_TRUE';
export const FETCH_HOSTED_LINKS_SUCCESS = 'FETCH_HOSTED_LINKS_SUCCESS';
export const FETCH_HOSTED_LINKS_FAILURE = 'FETCH_HOSTED_LINKS_FAILURE';
export const DELETE_LINK_SUCCESS = 'DELETE_LINK_SUCCESS';
export const DELETE_LINK_FAILURE = 'DELETE_LINK_FAILURE';
export const ADD_COLLAB_SUCCESS = 'ADD_COLLAB_SUCCESS';
export const ADD_COLLAB_FAILURE = 'ADD_COLLAB_FAILURE';
export const REMOVE_COLLAB_SUCCESS = 'REMOVE_COLLAB_SUCCESS';
export const REMOVE_COLLAB_FAILURE = 'REMOVE_COLLAB_FAILURE';
export const FETCH_COLLAB_SUCCESS = 'FETCH_COLLAB_SUCCESS';
export const FETCH_COLLAB_FAILURE = 'FETCH_COLLAB_FAILURE';
export const FETCH_LINK_DETAIL = 'FETCH_LINK_DETAIL';
